<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/ordemServico"> Manutenção/ordem Serviço </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="4">
            <v-subheader><strong>Prioridade</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="prioridade" row>
                <v-radio label="Normal" value="N"></v-radio>
                <v-radio label="Emergencial" value="E"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="equipamentoSelected"
              :items="equipamentos"
              label="Equipamento *"
              item-text="centroCusto"
              item-value="id"
              persistent-hint
              return-object
              v-on:change="changeEquipamento()"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Equipamento é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-subheader><strong>Tipo OS</strong></v-subheader>
            <hr />
            <div class="flex-center">
              <v-radio-group v-model="tipo" v-on:change="changeTipo()" row>
                <v-radio label="Corretiva" value="CR"></v-radio>
                <v-radio label="Preventiva" value="PV"></v-radio>
                <v-radio label="Preditiva" value="PD"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="planoManutencaoSelected"
              :items="planosEquipamento"
              label="Plano manutenção"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              v-on:change="changePlano()"
              :loading="loadingPlanos"
              :readonly="readOnly"
              :disabled="tipo != 'PV'"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="periodicidadeSelected"
              :items="periodicidadePlanos"
              label="Periodicidade"
              item-text="quantidadeHoras"
              item-value="id"
              persistent-hint
              return-object
              :loading="loadingPeriodos"
              v-on:change="changePeriodo()"
              :readonly="readOnly"
              :disabled="!planoManutencaoSelected"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="right">
          <v-col cols="12" sm="6" md="4" class="text-left">
            <v-menu
              v-model="menuData1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDataIni"
                  label="Data inicio"
                  prepend-icon="mdi-calendar"
                  v-mask="['##/##/####']"
                  maxlength="10"
                  v-bind="attrs"
                  v-on="on"
                  @input="onInputDate1"
                  @click:clear="dataIni = null"
                  clearable
                  :rules="[(v) => !!v || 'A data inicial é obrigatória']"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataIni"
                @input="menuData1 = false"
                @change="dateChangeDataIni"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="text-left">
            <v-menu
              v-model="menuData2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDataFim"
                  label="Data fim"
                  prepend-icon="mdi-calendar"
                  v-mask="['##/##/####']"
                  maxlength="10"
                  v-bind="attrs"
                  v-on="on"
                  @input="onInputDate2"
                  @click:clear="dataFim = null"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataFim"
                @input="menuData2 = false"
                @change="dateChangeDataFim"
                locale="pt-br"
                forma
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              label="Hora Inicial"
              v-model="horaInicio"
              v-mask="['##:##']"
              :counter="5"
              maxlength="5"
              :rules="[
                (v) => !!v || 'A Hora Inicial é obrigatória',
                (v) =>
                  (v && this.validaHora(v)) || 'A Hora Inicial deve ser válida',
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-text-field
              label="Hora Final"
              v-model="horaFim"
              v-mask="['##:##']"
              :counter="5"
              maxlength="5"
              :rules="[
                (v) => {
                  if (!v) return true;
                  return validaHora(v) || 'A Hora Final deve ser válida';
                },
              ]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="right">
          <v-col cols="12" sm="6" md="3" class="text-left">
            <v-text-field
              label="Horímetro Inicial"
              v-model.number="horimetroInicial"
              class="compact-input"
              type="number"
              :rules="[
                rules.naoNegativo,
                (v) => !!v || 'O horimetro é obrigatório',
              ]"
              required
            />
          </v-col>
          <v-col cols="12" sm="6" md="3" class="text-left">
            <v-text-field
              label="Horímetro Final"
              v-model.number="horimetroFinal"
              class="compact-input"
              type="number"
              :rules="[rules.naoNegativo]"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              v-model="localizacaoSelected"
              :items="localizacoes"
              label="Localizações *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Localização é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              label="Informações Adicionais"
              v-model="informacoesAdicionais"
              v-uppercase
              clear-icon="mdi-close-circle"
              maxlength="200"
              counter
              rows="1"
              clearable
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="mecanicoSelected"
              :items="mecanicos"
              label="Mecânico *"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Mecânico é obrigatório']"
              required
              :filter="customFilter"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="lubrificadorSelected"
              :items="mecanicos"
              label="Lubrificador"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Lubrificador é obrigatório']"
              required
              :readonly="isAllowed"
              :filter="customFilter"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="eletricistaSelected"
              :items="mecanicos"
              label="Eletricista"
              item-text="nome"
              item-value="id"
              persistent-hint
              return-object
              :filter="customFilter"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Eletricista é obrigatório']"
              required
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center" v-if="tipo != 'PV'">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addServico()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar Serviço</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-snackbar v-model="errorMessage" color="error" timeout="3000"
        >{{ errorMessageValue }}
      </v-snackbar>

      <v-form ref="formProd" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            :headers="filteredHeaders"
            hide-default-footer
            :loading="loadingServicos"
            :items="servicosL"
            :items-per-page="-1"
          >
            <template v-slot:item.detalhe="{ item }">
              <v-text-field v-model="item.detalhe"> </v-text-field>
            </template>
            <template v-slot:item.execucao="{ item }">
              <div v-if="!item.editingExecucao">
                <div
                  @click="item.editingExecucao = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.execucao && item.execucao.valor) ||
                    execucoes.find((e) => e.id === item.execucao).valor
                  }}
                </div>
              </div>
              <v-autocomplete
                v-else
                v-model="item.execucao"
                :items="execucoes"
                item-text="valor"
                item-value="id"
                persistent-hint
                return-object
                :readonly="isAllowed"
                autofocus
                @blur="
                  () => {
                    item.editingExecucao = false;
                  }
                "
                @change="
                  (val) => {
                    changeServico(item.index, val);
                    item.editingExecucao = false;
                  }
                "
              >
              </v-autocomplete>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeServico(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            
            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="filteredHeaders.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ servicosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>

      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
            <v-btn
              :to="{ path: '/ordemServico', query: $route.query }"
              color="primary"
              class="mr-4"
            >
              Voltar
            </v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Serviço</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <produto
                ref="prdAdd"
                :servicosL="servicosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviarOrdemServicoAsync } from "../../../services/ordemServicoService";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import Produto from "./Produto";
import {
  ordenarItensPlanoManutencao,
  reindexarItensPlanoManutencao,
} from "../../../utils/planoManutencaoItens";

export default {
  name: "criarOrdemServico",
  data: () => ({
    overlay: false,
    valid: true,
    tipo: "CR",
    prioridade: "N",
    unidadeAdmSelected: null,
    equipamentoSelected: null,
    dataIni: null,
    dataFim: null,
    horimetroInicial: null,
    horimetroFinal: null,
    horaInicio: null,
    horaFim: null,
    planoManutencaoSelected: null,
    periodicidadeSelected: null,
    mecanicoSelected: null,
    eletricistaSelected: null,
    lubrificadorSelected: null,
    localizacaoSelected: null,
    loadingPlanos: false,
    loadingPeriodos: false,
    loadingServicos: false,
    informacoesAdicionais: null,
    menuData1: false,
    menuData2: false,
    showModal: false,
    errorMessageValue: null,
    servicosL: [],
    execucoes: [
      { id: 0, valor: "pendente" },
      { id: 1, valor: "executado" },
    ],
    headersBase: [
      { text: "Item", value: "index", sortable: false },
      { text: "Compartimento", value: "compartimento", sortable: false },
      { text: "Serviço", value: "descricao", sortable: false },
      { text: "Código", value: "codigo", sortable: false },
      { text: "Detalhar Serviço", value: "detalhe", sortable: false },
      {
        text: "Execução",
        value: "execucao",
        width: "15%",
      },
      { text: "", value: "actions", sortable: false },
    ],
    rules: {
      naoNegativo: (v) =>
        v === null || v === "" || v >= 0 || "Não pode ser negativo",
    },
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("local", ["locais"]),
    ...mapState("mecanico", ["mecanicos"]),
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("localizacao", ["localizacoes"]),
    ...mapState("planoManutencao", ["planosEquipamento"]),
    ...mapState("periodicidade", ["periodicidadePlanos"]),
    ...mapState("servicoPlano", ["servicosPlanoPeriodos"]),
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
    filteredHeaders() {
      return this.headersBase.filter((header) => {
        if (
          !header.value ||
          header.value === "actions" ||
          header.value === "detalhe"
        )
          return true; // Sempre mostra ações

        // Verifica se existe pelo menos um valor não nulo ou não vazio para essa coluna
        return this.servicosL.some((item) => {
          const val = item[header.value];
          return val !== null && val !== undefined && val !== "";
        });
      });
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarServicosInterno"]),
    ...mapActions("planoManutencao", ["atualizarPlanosEquipamento"]),
    ...mapActions("periodicidade", ["atualizarPeriodoPorPlano"]),
    ...mapActions("servicoPlano", ["atualizarServicosPlanoPeriodos"]),
    async enviar() {
      if (this.servicosL == null || this.servicosL.length <= 0) {
        this.errorMessageValue = "Adicione os serviços!";
        this.errorMessage = true;
      } else if (this.$refs.form.validate()) {
        this.overlay = true;
        try {
          const resposta = await enviarOrdemServicoAsync(
            this.tipo,
            this.prioridade,
            this.unidadeAdmSelected.id,
            this.equipamentoSelected.id,
            this.planoManutencaoSelected
              ? this.planoManutencaoSelected.id
              : null,
            this.periodicidadeSelected ? this.periodicidadeSelected.id : null,
            this.mecanicoSelected.id,
            this.lubrificadorSelected.id,
            this.eletricistaSelected.id,
            this.localizacaoSelected.id,
            this.informacoesAdicionais,
            this.dataIni,
            this.dataFim,
            this.horaInicio,
            this.horaFim,
            this.horimetroInicial,
            this.horimetroFinal,
            this.servicosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message || "",
              "Descupe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push("/ordemServico");
          }
        } finally {
          this.overlay = false;
        }
      }
    },
    addServico: function () {
      this.showModal = true;
    },
    removeServico(index) {
      this.servicosL = reindexarItensPlanoManutencao(
        this.servicosL.filter((p) => p.index != index)
      );
    },

    changeServico(index, execucao) {
      const rowIdx = this.servicosL.findIndex((s) => s.index === index);
      if (rowIdx === -1) return;
      this.$set(this.servicosL[rowIdx], "execucao", execucao);
      this.$set(
        this.servicosL[rowIdx],
        "executado",
        execucao.id == 0 ? false : true
      );
    },
    async obterListas() {
      await this.atualizarServicosInterno();
    },

    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },

    validaHora(val) {
      if (/^\d{2}:\d{2}$/.test(val)) {
        var [h, m] = val.split(":").map(Number);
        if (h >= 0 && h <= 23 && m >= 0 && m <= 59) {
          return true;
        }
      }
      return false;
    },
    async changeTipo() {
      if (this.tipo == "PV" && this.equipamentoSelected) {
        this.loadingPlanos = true;
        await this.atualizarPlanosEquipamento(this.equipamentoSelected.id);
        this.loadingPlanos = false;
      } else {
        this.planoManutencaoSelected = null;
        this.periodicidadeSelected = null;
        this.servicosL = [];
      }
    },
    async changeEquipamento() {
      this.planoManutencaoSelected = null;
      this.periodicidadeSelected = null;
      this.servicosL = [];
      if (this.tipo == "PV") {
        this.loadingPlanos = true;
        await this.atualizarPlanosEquipamento(this.equipamentoSelected.id);
        this.loadingPlanos = false;
      }
    },
    async changePlano() {
      const idPeriodicidadeAtual = this.periodicidadeSelected
        ? this.periodicidadeSelected.id
        : null;
      this.servicosL = [];

      if (!this.planoManutencaoSelected) {
        this.periodicidadeSelected = null;
        return;
      }

      this.loadingPeriodos = true;
      await this.atualizarPeriodoPorPlano(this.planoManutencaoSelected.id);
      this.loadingPeriodos = false;

      if (!idPeriodicidadeAtual) {
        this.periodicidadeSelected = null;
        return;
      }

      const periodicidadeValida = this.periodicidadePlanos.find(
        (p) => p.id === idPeriodicidadeAtual
      );
      this.periodicidadeSelected = periodicidadeValida || null;

      if (periodicidadeValida) {
        await this.changePeriodo();
      }
    },
    async changePeriodo() {
      if (!this.planoManutencaoSelected || !this.periodicidadeSelected) {
        this.servicosL = [];
        return;
      }

      this.loadingServicos = true;
      await this.atualizarServicosPlanoPeriodos({
        idPlano: this.planoManutencaoSelected.id,
        idPeriodicidade: this.periodicidadeSelected.id,
      });

      const servicosOrdenados = ordenarItensPlanoManutencao(
        this.servicosPlanoPeriodos
      );
      this.servicosL = reindexarItensPlanoManutencao(servicosOrdenados).map(
        (s) => ({
          ...s,
          execucao: 0,
          executado: false,
          editingExecucao: false,
          idServicoPlano: s.id,
          id: 0,
        })
      );
      this.loadingServicos = false;
    },
    customFilter(item, queryText) {
      const q = (queryText || "").toString().toLowerCase().trim();

      // Se não tem busca, não filtra nada
      if (!q) return true;

      const nome = (item?.nome || "").toString().toLowerCase();
      const cargo = (item?.cargo || "").toString().toLowerCase();

      // itemText é o texto "principal" (nome) que o Vuetify já calcula,
      // mas aqui a gente garante com nome/cargo.
      return nome.includes(q) || cargo.includes(q);
    },
  },
  created: function () {
    this.obterListas();
  },
  components: {
    Produto,
  },
};
</script>
